import { render } from "./GradientText.vue?vue&type=template&id=dc2c0f96&scoped=true"
import script from "./GradientText.vue?vue&type=script&lang=js"
export * from "./GradientText.vue?vue&type=script&lang=js"

import "./GradientText.vue?vue&type=style&index=0&id=dc2c0f96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc2c0f96"]])

export default __exports__